import script from "./TheRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRegister.vue?vue&type=script&setup=true&lang=js"

import "./TheRegister.vue?vue&type=style&index=0&id=1f023274&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f023274"]])

export default __exports__